module.exports = __webpack_public_path__ + "static/img/4.11e968d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v14_new_features/4.png
// module id = swez
// module chunks = 0